import common from "./common.json";
import home from "./home.json";
import camp from "./camp.json";
import education from "./education.json";
import news from "./news.json";
import aboutUs from "./aboutUs.json";

const trans = {
  common,
  home,
  camp,
  education,
  news,
  aboutUs,
};

export default trans;
